// extracted by mini-css-extract-plugin
export default {"mealSelectorBody":"MealSelectorBody-module__mealSelectorBody___2XI_n","footer":"MealSelectorBody-module__footer___gvP2b"};